import {combineReducers} from 'redux'
import CurrentUserReducer from '../currentUser/CurrentUserReducer'
import storage from 'redux-persist/lib/storage'
import {persistReducer} from 'redux-persist'

const userConfig = {
  key: 'globalStates',
  storage,
}         

const RootReducer = combineReducers({
  globalStates: persistReducer(userConfig, CurrentUserReducer),
})

export default RootReducer
